import { numberInputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from '../shared/themeShared';

const style = createMultiStyleConfigHelpers(numberInputAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    // define the part you're going to style
    field: {
      borderRadius: getThemes(theme).radii.lg,
    },
  });

const outline = (theme: ThemesKeys) =>
  style.definePartsStyle({
    field: {
      borderRadius: getThemes(theme).radii.lg,
      bg: 'white',
      border: 0,
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.primary[80]}`,
      _focusVisible: {
        zIndex: 1,
        boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.primary[50]}`,
      },
      _placeholder: {
        color: getThemes(theme).colors.palette.text.secondary[80],
      },
      _disabled: {
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
        backgroundColor: 'white',
        opacity: 1,
      },
      _hover: {
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.primary[50]}`,
        _disabled: {
          boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
        },
      },
    },
    root: {
      borderRadius: getThemes(theme).radii.lg,
      height: 'full',
    },
    stepperGroup: {
      w: '50px',
      height: 'full',
      mt: 0,
      mb: 0,
      mr: 0,
      ml: 0,
    },
    stepper: {
      color: getThemes(theme).colors.palette.text.primary[50],
      borderLeft: `1px solid ${getThemes(theme).colors.palette.primary[80]}`,
      _first: {
        borderTopRightRadius: getThemes(theme).radii.lg,
      },
      _last: {
        m: 0,
        borderBottomRightRadius: getThemes(theme).radii.lg,
        borderTop: `1px solid ${getThemes(theme).colors.palette.primary[80]}`,
      },
      _active: {
        color: getThemes(theme).colors.palette.primary[100],
        bg: getThemes(theme).colors.palette.primary[50],
      },
    },
  });

const counter = (theme: ThemesKeys) =>
  style.definePartsStyle({
    field: {
      w: 24,
      mx: 3.5,
      bg: 'white',
      borderRadius: getThemes(theme).radii.lg,
      border: 0,
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.primary[80]}`,
      _hover: {
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.primary[50]}`,
      },
      _focusVisible: {
        zIndex: 1,
        boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.primary[50]}`,
      },
      _disabled: {
        color: getThemes(theme).colors.palette.primary[0],
        opacity: 1,
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
        bg: 'white',
        _hover: {
          boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
        },
      },
    },
    root: {
      borderRadius: getThemes(theme).radii.lg,
      height: 'full',
    },
  });

export const inputNumberTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    variants: {
      outline: outline(theme),
      counter: counter(theme),
    },
  });

export default (theme: ThemesKeys) => inputNumberTheme(theme);
